import { render, staticRenderFns } from "./PetTrackingDeviceMarketingContentBlock.vue?vue&type=template&id=4855cb29&scoped=true&"
import script from "./PetTrackingDeviceMarketingContentBlock.vue?vue&type=script&lang=js&"
export * from "./PetTrackingDeviceMarketingContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./PetTrackingDeviceMarketingContentBlock.vue?vue&type=style&index=0&id=4855cb29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855cb29",
  null
  
)

export default component.exports